var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47468 13.0255C5.97403 15.5248 10.0263 15.5248 12.5256 13.0255C15.025 10.5261 15.025 6.47387 12.5256 3.97452C10.0263 1.47516 5.97403 1.47516 3.47468 3.97452C0.975321 6.47387 0.975321 10.5261 3.47468 13.0255ZM2.34331 14.1569C5.4675 17.281 10.5328 17.281 13.657 14.1569C16.7812 11.0327 16.7812 5.96734 13.657 2.84315C10.5328 -0.281049 5.4675 -0.281049 2.34331 2.84315C-0.780888 5.96734 -0.780888 11.0327 2.34331 14.1569Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4515 6.04871C10.7639 6.36113 10.7639 6.86766 10.4515 7.18008L6.68022 10.9513C6.3678 11.2637 5.86127 11.2637 5.54885 10.9513C5.23643 10.6389 5.23643 10.1324 5.54885 9.81994L9.32009 6.04871C9.63251 5.73629 10.139 5.73629 10.4515 6.04871Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4514 10.9513C10.139 11.2637 9.63247 11.2637 9.32005 10.9513L5.54881 7.18002C5.23639 6.8676 5.23639 6.36107 5.54881 6.04865C5.86123 5.73623 6.36777 5.73623 6.68018 6.04865L10.4514 9.81989C10.7638 10.1323 10.7638 10.6388 10.4514 10.9513Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundClose);
export default __webpack_public_path__ + "static/media/round-close.26ac4133f9ca73a278f336f1067f04a0.svg";
export { ForwardRef as ReactComponent };